import React from "react";
import "./RadioInput.css";

const RadioInput = ({
  isChecked,
  textValue,
  handleAnswer,
  otherParams,
  isOther,
  customStyle,
  isInError,
  isChildAnswer,
}) => {
  const handleRadioState = (value) => {
    if (otherParams !== undefined) {
      handleAnswer(otherParams[0], value, otherParams[1]);
    }
  };
  return (
    <div
      className={
        (customStyle
          ? "customFormField "
          : !isChildAnswer
          ? "questionareField_container "
          : "questionareField_container_child ") +
        (isChecked && !isChildAnswer
          ? "container_checked container_checked_border"
          : isChecked && isChildAnswer
          ? "container_checked"
          : "") +
        (isInError ? " container_error" : "")
      }
      onClick={() => handleRadioState(textValue)}
    >
      <div className="questionareField_radio_container">
        <div className={"questionareField_radio_box " + (isChecked ? "radio_checked" : "")}>
          <div className={"questionareField_radio_box_inner " + (isChecked ? "container_checked" : "")}></div>
        </div>
      </div>
      <div className="questionareField_question">{textValue}</div>
      {isChecked && isOther && (
        <input
          type="text"
          className="questionareField_additional_inp"
          onChange={(e) => handleRadioState(e.target.value)}
        />
      )}
    </div>
  );
};

export default RadioInput;
